import Vue from "vue"
import Buefy from "buefy"
import "@/assets/scss/app.scss"
const moment = require("moment-timezone")

Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultMonthNames: [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre"
  ],
  defaultDayNames: ["D", "L", "Ma", "Me", "G", "V", "S"],
  defaultFirstDayOfWeek: 1,
  defaultDateCreator: moment()
    .tz("Europe/Rome")
    .toDate(),
  defaultDateParser: date => moment(date).format("YYYY-MM-DD"),
  defaultDateFormatter: date => date.toLocaleDateString("it-IT")
})
